var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-select" },
    [
      _c("el-input", {
        staticStyle: { border: "none" },
        attrs: {
          disabled: _vm.disabled,
          placeholder: "请选择终端",
          readOnly: "",
          value: _vm.value ? _vm.value.terminalName : "",
        },
        nativeOn: {
          click: function ($event) {
            return _vm.openModal.apply(null, arguments)
          },
        },
      }),
      _c("SelectConfig", {
        ref: "selectConfig",
        on: { onGetSelect: _vm.onGetSelect },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }